import { gql } from '@apollo/client';

export default gql`
  mutation RemoveTeamPriority($teamId: Int!) {
    removeTeamPriority(teamId: $teamId) {
      id
    }
  }
`;
